var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _vm.title
        ? _c("div", { staticClass: "mb-40 d-flex flex-wrap w-100" }, [
            _vm.title
              ? _c("h3", {
                  staticClass: "title",
                  domProps: { innerHTML: _vm._s(_vm.title) }
                })
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "slide-y-down-transition",
        {
          staticClass: "success-factors-row row mb-n40 mb-lg-0",
          attrs: { group: "", tag: "div" }
        },
        _vm._l(_vm.successFactors, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "col-12 col-md-6 mb-40 mb-lg-0 col-lg-4"
            },
            [
              _c("div", { staticClass: "success-factor" }, [
                _c("span", { staticClass: "icon d-block mb-24" }, [
                  _c("i", { class: item.icon })
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "subtitle d-inline-block mb-8" }, [
                  _vm._v(_vm._s(item.title))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "font-weight-light" }, [
                  _vm._v(_vm._s(item.description))
                ])
              ])
            ]
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }